import React from "react";
import { Table, Select } from "antd";
import { useSelector } from "react-redux";
import { useProjectState } from "../../../context/stateContext";

const { Option } = Select;

const SalesInfoTable = () => {
  const { items, total, loading } = useSelector(
    (state) => state.salesInfoReducer
  );

  const {
    dataProducts,
    setDataProducts,
    allSectedProducts,
    setAllSelectedProducts,
  } = useProjectState();

  const getTotalSum = () => {
    let turnoverSum = 0;
    if (dataProducts.length === 0) return total;
    else {
      dataProducts.forEach((element) => {
        turnoverSum += element.sum;
      });
      return turnoverSum;
    }
  };

  const columns = [
    {
      title: "Име",
      dataIndex: "name",
      rowKey: "name",
      width: "50%",
      sorter: (a, b) => a.name.localeCompare(b.name),
      key: "name",
      render: (text) => <span className="sales-info-table-text">{text}</span>,
    },
    {
      title: "Брой",
      dataIndex: "count",
      rowKey: "count",
      width: "10%",
      sorter: (a, b) => a.count - b.count,
      align: "center",
      key: "count",

      render: (text) => <span className="sales-info-table-text">{text}</span>,
    },
    {
      title: () => {
        return (
          <div className="sales-info-table-total-column">
            Общо{" "}
            {getTotalSum()
              .toFixed(2)
              .toString()
              .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
              .replace(",", " ")}
          </div>
        );
      },
      dataIndex: "sum",
      rowKey: "sum",
      key: "sum",
      align: "right",
      sorter: (a, b) => a.sum - b.sum,
      width: "25%",
      render: (text) => (
        <span className="sales-info-table-text">
          {(isNaN(parseFloat(text)?.toFixed(2))
            ? parseFloat(0).toFixed(2)
            : parseFloat(text)?.toFixed(2)) === 0
            ? "-"
            : isNaN(parseFloat(text)?.toFixed(2))
            ? parseFloat(0).toFixed(2)
            : parseFloat(text)?.toFixed(2)}
        </span>
      ),
    },
  ];

  const handleOnSelectProduct = (product) => {
    const selectedProduct = items.filter((item) => {
      return item.name === product;
    });

    setAllSelectedProducts((prevSelectedProducts) => [
      ...prevSelectedProducts,
      product,
    ]);

    setDataProducts((prevSelectedProducts) => [
      ...prevSelectedProducts,
      selectedProduct[0],
    ]);
  };

  const handleDeSelectProduct = (productToRemove) => {
    const unselectedProduct = items.filter((item) => {
      return item.name === productToRemove;
    });

    setAllSelectedProducts((prevSelectedProducts) =>
      prevSelectedProducts.filter((product) => product !== productToRemove)
    );

    setDataProducts((prevSelectedProducts) =>
      prevSelectedProducts.filter((product) => product !== unselectedProduct[0])
    );
  };

  return (
    <div className="sales-info-table-container">
      <Select
        virtual={false}
        key="salesInfoTableSelect"
        mode="multiple"
        placeholder="Филтрирайте по продукт"
        onSelect={handleOnSelectProduct}
        onDeselect={handleDeSelectProduct}
        value={allSectedProducts}
        className="sales-info-table-selector"
      >
        {items?.map((item, index) => (
          <Option key={index} value={item.name}>
            {item.name}
          </Option>
        ))}
      </Select>
      <Table
        loading={loading}
        rowKey={(record) => `${record.name}_${record.categoryId}`}
        showHeader
        dataSource={dataProducts.length === 0 ? items : dataProducts}
        columns={columns}
        pagination={false}
        className="sales-info-table"
      />
    </div>
  );
};

export default SalesInfoTable;
